<script lang="ts">
    import type { TNavItem } from './types';

    export let item: TNavItem;

    const { href, text, testid } = item;
</script>

<a
    {href}
    class="px-xs pb-[6px] text-xs font-bold text-white tablet:px-lg tablet:text-base"
    data-testid={testid}
>
    {text}
</a>
